export default __webpack_public_path__ + "static/media/cancel-circle.269287a8.svg";